import { cn } from '@/utils/cn'

interface EmptyStateProps {
  icon?: string
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  className?: string
}

/**
 * Generic empty-state placeholder for lists, tables, and content areas
 * that have no data to show yet.
 */
export function EmptyState({
  icon = '📭',
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-16 px-8 text-center',
        'border border-dashed border-[var(--border)] rounded-[var(--radius)]',
        'bg-[var(--surface2)]',
        className
      )}
    >
      <div className="text-[40px] mb-4 opacity-50">{icon}</div>

      <h3
        className="text-[14px] font-bold text-[var(--text)] mb-1"
        style={{ fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}
      >
        {title}
      </h3>

      {description && (
        <p className="text-[12px] text-[var(--text-muted)] font-mono max-w-xs leading-relaxed mb-5">
          {description}
        </p>
      )}

      {action && (
        <button
          onClick={action.onClick}
          className={cn(
            'px-4 py-2 rounded-[var(--radius-sm)] text-white font-mono text-[12px]',
            'bg-[var(--accent)] hover:opacity-90 transition-opacity'
          )}
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
